import Layout from 'v3/templates/Layout';

import * as S from './styles';

type GeneralTypes = {
  children: React.ReactNode;
  hasHeaderLinks?: boolean;
  hideFooter?: boolean;
};

const General = ({
  children,
  hasHeaderLinks = true,
  hideFooter = false,
}: GeneralTypes) => {
  return (
    <Layout hasHeaderLinks={hasHeaderLinks} hideFooter={hideFooter}>
      <S.Wrapper>
        <S.Container>
          <S.Row justify="center">{children}</S.Row>
        </S.Container>
      </S.Wrapper>
    </Layout>
  );
};

export default General;
